<div class="app-preview-links" *ngIf="gBookPreviewLink">
  <div class="app-preview-links__google-preview mt-4" *ngIf="gBookPreviewLink">
    <a [href]="gBookPreviewLink"
      target="_blank"
      [attr.aria-label]="'googleBookPreview' | translate">
      <img src="https://books.google.com/intl/en/googlebooks/images/gbs_preview_button1.gif" alt="" role="presentation"></a>
  </div>
</div>
